module.exports = __webpack_public_path__ + "static/media/S (126).aad1dad9.jpg";